import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjDownLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.72,2.22l-3.72,3.72V3.24c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V7.75c0,.414,.336,.75,.75,.75h4.511c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75h-2.7l3.72-3.72c.293-.293,.293-.768,0-1.061s-.768-.293-1.061,0Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "9", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjDownLeftFill18.js.map